import { getMontageAddress, MontageAddressType } from "@util/order-utils";
import { isJsObject } from "@util/utils";
import { ICellRenderer, ICellRendererParams } from "ag-grid-community";

let enableMeasure = false;
let times: any[] = [];

if(enableMeasure) {
  setInterval(() => {
    let tSum = 0;
    for (let t of times) {
      tSum += t;
    }

    tSum > 0 && console.log('Time:', hasPerformance, times.length, tSum);
    times = [];
  }, 10 * 1000);
}


const hasPerformance = !!window.performance && !!window.performance.now;
function getTime() {
  return hasPerformance ? window.performance.now() : (new Date()).getTime();
}

const addrMAG = '<div class="mag-werkstatt-montage-location" style="padding:8px 0;">MAG Werkstatt</div>';
const addrUnknown = '<div style="padding:8px;color:red;">Adresse unbekannt</div>';

/**
 *
 */
export class OrderCustomerRenderer implements ICellRenderer {
  private eGui!: HTMLElement;

  init(params: ICellRendererParams) {
    //this.initOld(params);
    this.initNew(params);
  }

  initNew(params: ICellRendererParams) {
    const st = getTime();
    const elem = document.createElement('div');
    elem.className = 'grid-cell-customer';

    const data = params.data;

    const cellParams = params?.colDef?.cellRendererParams;

    let onlyName = false;

    if (isJsObject(cellParams)) {
      onlyName = !!cellParams.onlyName;
    }

    if (data && data.customer) {
      const customer = data.customer;
      let content = '<div>' + customer.first_name + ' ' + customer.last_name + '</div>';
      if(!onlyName && !customer.only_name) {
        const addrType = getMontageAddress(data);

        if (addrType === MontageAddressType.HOME_ADDRESS) {
          if (customer.address) {
            content += '<div>' + customer.address + '</div>';
          }
          let z = customer.zip || '';
          let c = customer.city || '';

          if (z || c) {
            content += '<div>' + ((z && c) ? (z + ' ' + c) : (z ? z : c)) + '</div>';
          }
        } else if (addrType === MontageAddressType.MAG_WERKSTATT) {
          content += addrMAG;
        } else if (addrType === MontageAddressType.CUSTOM_ADDRESS) {
          if (customer.montage_address) {
            content += '<div>' + customer.montage_address + '</div>';
          }
          let z = customer.montage_zip || '';
          let c = customer.montage_city || '';

          if (z || c) {
            content += '<div>' + ((z && c) ? (z + ' ' + c) : (z ? z : c)) + '</div>';
          }
        } else {
          content += addrUnknown;
        }

        if (customer.phone) {
          content += '<div style="padding-top:4px; padding-bottom:4px;">Tel: ' + customer.phone + '</div>';
        }
        if (customer.mobile) {
          content += '<div style="padding-top:4px; padding-bottom:4px;">Mobil: ' + customer.mobile + '</div>';
        }
      }

      elem.innerHTML = content;
    }

    enableMeasure && times.push(getTime() - st);
    this.eGui = elem;
  }

  initOld(params: ICellRendererParams) {
    const st = getTime();

    const elem = document.createElement('div');
    elem.className = 'grid-cell-customer';

    const data = params.data;

    if (data && data.customer) {
      const customer = data.customer;
      const nameElem = document.createElement('div');
      nameElem.textContent = customer.first_name + ' ' + customer.last_name;
      elem.appendChild(nameElem);
      const addrType = getMontageAddress(data);

      if (addrType === MontageAddressType.HOME_ADDRESS) {
        if (customer.address) {
          const addressElem = document.createElement('div');
          addressElem.textContent = customer.address;
          elem.appendChild(addressElem);
        }

        const parts: any[] = [];

        if (customer.zip) {
          parts.push(customer.zip);
        }
        if (customer.city) {
          parts.push(customer.city);
        }

        if (parts.length > 0) {
          const zipCityElem = document.createElement('div');

          zipCityElem.textContent = parts.join(' ');
          elem.appendChild(zipCityElem);
        }
      } else if (addrType === MontageAddressType.MAG_WERKSTATT) {
        const addressElem = document.createElement('div');
        addressElem.style.padding = '8px 0';
        addressElem.className = 'mag-werkstatt-montage-location';
        addressElem.textContent = 'MAG Werkstatt';
        elem.appendChild(addressElem);
      } else if (addrType === MontageAddressType.CUSTOM_ADDRESS) {
        const addressElem = document.createElement('div');
        addressElem.textContent = data.montage_address;
        elem.appendChild(addressElem);

        const parts: any[] = [];

        if (data.montage_zip) {
          parts.push(data.montage_zip);
        }
        if (data.montage_city) {
          parts.push(data.montage_city);
        }

        if (parts.length > 0) {
          const zipCityElem = document.createElement('div');

          zipCityElem.textContent = parts.join(' ');
          elem.appendChild(zipCityElem);
        }
      } else {
        const addressElem = document.createElement('div');
        addressElem.style.padding = '8px';
        addressElem.style.color = 'red';
        addressElem.textContent = 'Adresse unbekannt';
        elem.appendChild(addressElem);
      }

      if (customer.phone) {
        const telElem = document.createElement('div');
        telElem.style.paddingTop = '4px';
        telElem.style.paddingBottom = '4px';
        telElem.textContent = 'Tel: ' + customer.phone;
        elem.appendChild(telElem);
      }
      if (customer.mobile) {
        const mobileElem = document.createElement('div');
        mobileElem.style.paddingTop = '4px';
        mobileElem.style.paddingBottom = '4px';
        mobileElem.textContent = 'Mobil: ' + customer.mobile;
        elem.appendChild(mobileElem);
      }
    }
    enableMeasure && times.push(getTime() - st);

    this.eGui = elem;
  }

  getGui() {
    return this.eGui;
  }

  refresh() {
    return false;
  }
}
